import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M13.6 4l8.2 14.3c.3.6.3 1.3-.1 1.9-.3.6-.9.9-1.6.9H3.9c-.7 0-1.3-.3-1.6-.9-.3-.6-.3-1.3 0-1.9L10.4 4c.3-.6.9-1 1.6-1 .7 0 1.3.4 1.6 1zM12 5.1l-7.9 14H20l-8-14zm-2.8 9.4c-.2-.3-.2-.7 0-1l2-3c.3-.5.9-.6 1.4-.1.5.3.6.9.3 1.4l-1 1.4h2c.4 0 .7.2.9.5.2.3.2.7 0 1l-2 3c-.2.2-.5.4-.8.4-.2 0-.4-.1-.6-.2-.4-.3-.5-.9-.2-1.5l1-1.4h-2.1c-.4 0-.7-.2-.9-.5z" />,
  'Warning'
)
